import { render, staticRenderFns } from "./DetailMain.vue?vue&type=template&id=563fa59d&scoped=true"
import script from "./DetailMain.vue?vue&type=script&lang=js"
export * from "./DetailMain.vue?vue&type=script&lang=js"
import style0 from "./DetailMain.vue?vue&type=style&index=0&id=563fa59d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563fa59d",
  null
  
)

export default component.exports